import * as THREE from 'three';
import { params } from '../config.js';
import * as SceneModule from '../scene.js';
import { mouseControl, airplaneState } from '../airplane/state.js';

// Mouse NDC for hover effects (exported for use in main.js)
export const mouseNdc = new THREE.Vector2(-2, -2);

// Right-click drag for camera orbit around airplane
export const cameraOrbit = {
  isDragging: false,
  lastX: 0,
  lastY: 0,
  azimuth: 0,       // horizontal angle (radians)
  elevation: 0,     // vertical angle offset (radians) - for pitch adjustment
  sensitivity: 0.005,
  // Min/max elevation for each mode (radians)
  elevationLimits: {
    chase: { min: -0.3, max: 0.5 },
    topdown: { min: -0.2, max: 0.2 }  // limited for top-down
  },
  // Easing for returning to default position
  easeSpeed: 3.0  // how fast to ease back (radians per second equivalent)
};

// Check if camera orbit is allowed (only when landed)
function canOrbitCamera() {
  return airplaneState.flightState === 'landed';
}

// Touch tap detection

export function setupMouseControls() {
  const { canvasContainer } = SceneModule;
  // Mouse tracking for hover effects and airplane direction control
  canvasContainer.addEventListener('mousemove', (e) => {
    const rect = canvasContainer.getBoundingClientRect();
    mouseNdc.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    mouseNdc.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
    
    // Update airplane direction based on mouse position
    // X position controls turn rate (-1 to 1, continuous turning)
    // Y position controls climb rate (-1 to 1, continuous altitude change)
    mouseControl.active = true;
    mouseControl.turnRate = mouseNdc.x;   // -1 (left) to 1 (right)
    mouseControl.climbRate = mouseNdc.y;  // -1 (down) to 1 (up)
  });

  canvasContainer.addEventListener('mouseleave', () => {
    mouseNdc.set(-2, -2);
    mouseControl.active = false;
  });

  // Right-click drag for camera orbit (only when landed)
  canvasContainer.addEventListener('mousedown', (e) => {
    if (e.button === 2) { // Right click
      if (canOrbitCamera()) {
        cameraOrbit.isDragging = true;
        cameraOrbit.lastX = e.clientX;
        cameraOrbit.lastY = e.clientY;
      }
      e.preventDefault();
    }
  });

  window.addEventListener('mousemove', (e) => {
    if (!cameraOrbit.isDragging) return;
    
    // Stop dragging if no longer allowed (e.g., launched while dragging)
    if (!canOrbitCamera()) {
      cameraOrbit.isDragging = false;
      return;
    }
    
    const deltaX = e.clientX - cameraOrbit.lastX;
    const deltaY = e.clientY - cameraOrbit.lastY;
    cameraOrbit.lastX = e.clientX;
    cameraOrbit.lastY = e.clientY;
    
    // Update azimuth (horizontal orbit)
    cameraOrbit.azimuth -= deltaX * cameraOrbit.sensitivity;
    
    // Update elevation (vertical angle) with limits based on mode
    const mode = params?.cameraMode || 'chase';
    const limits = cameraOrbit.elevationLimits[mode] || { min: -0.5, max: 0.5 };
    cameraOrbit.elevation = Math.max(limits.min, Math.min(limits.max, 
      cameraOrbit.elevation + deltaY * cameraOrbit.sensitivity
    ));
  });

  window.addEventListener('mouseup', (e) => {
    if (e.button === 2) {
      cameraOrbit.isDragging = false;
    }
  });

  // Prevent context menu on right-click
  canvasContainer.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });

}
